import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
    palette: {
        primary: {
            main: '#00FF00',
            dark: '#00CC00',
            light: '#1AFF1A',
        },
        secondary: {
            main: '#000000',
            dark: '#000000',
            light: '#333333',
        }
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    borderRadius: '8px',
                }
            }
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                    }
                }
            }
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: '12px',
                    boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)'
                }
            }
        }
    }
});
